module.exports = __webpack_public_path__ + "img/details-three.689d20e0.png";